import RestService from "./RestService";

export default class CreditCardService extends RestService {
    constructor() {
        super('payments')
    }

    dealPaymentIntent() {
        let url = this.baseUrl + '/api/v1/deal-payment-intent.json?t=' + Date.now()
        return this.executeGet(url)
    }

    updatePaymentIntent(paymentIntentId, couponCode) {
        let url = this.baseUrl + `/api/v1/update-with-coupon/${paymentIntentId}/${couponCode}.json?t=${Date.now()}`
        return this.executeGet(url)
    }
}